if (!customElements.get('recipient-form')) {
customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
		constructor() {
			super();
			//this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${this.dataset.sectionId}`);
			//this.checkboxInput.disabled = false;
			this.hiddenControlField = this.querySelector(`#Recipient-Control-${this.dataset.sectionId}`);
			this.hiddenControlField.disabled = true;
			
			this.form = this.querySelector('form');
			this.form.querySelector('[name=id]').disabled = false;
			this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
			this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
			this.submitButton = this.querySelector('[type="submit"]');
			
			this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
			this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
			this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
            this.greetingExample = document.getElementById('greeting-example');
            this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
            this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
            if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();
            
			this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
			this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
			this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
			this.defaultErrorHeader = this.errorMessage?.innerText;
			this.currentProductVariantId = this.dataset.productVariantId;
			this.messageInput.addEventListener('keyup', this.messageChange.bind(this));
            //this.addEventListener('change', this.onChange.bind(this));
            //this.formValid();
		}

		cartUpdateUnsubscriber = undefined;
		variantChangeUnsubscriber = undefined;
		cartErrorUnsubscriber = undefined;

		connectedCallback() {
			this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
				if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
					this.resetRecipientForm();
				}
			});

			this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
				if (event.data.sectionId === this.dataset.sectionId) {
					this.currentProductVariantId = event.data.variant.id.toString();
				}
			});

			this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
				if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
					this.displayErrorMessage(event.message, event.errors);
				}
			});
		}

		disconnectedCallback() {
			if (this.cartUpdateUnsubscriber) {
				this.cartUpdateUnsubscriber();
			}

			if (this.variantChangeUnsubscriber) {
				this.variantChangeUnsubscriber();
			}

			if (this.cartErrorUnsubscriber) {
				this.cartErrorUnsubscriber();
			}
		}

		formValid() {
			return this.form.reportValidity();
		}

        messageChange(evt) {
            evt.stopPropagation();
            this.greetingExample.textContent = this.messageInput.value
        }

		onSubmitHandler(evt) {
			evt.preventDefault();

			if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
			if (this.formValid() === false) return;

			this.submitButton.setAttribute('aria-disabled', true);
			this.submitButton.classList.add('loading');
			this.querySelector('.loading__spinner').classList.remove('hidden');

			const config = fetchConfig('javascript');
			config.headers['X-Requested-With'] = 'XMLHttpRequest';
			delete config.headers['Content-Type'];

			const formData = new FormData(this.form);
			if (this.cart) {
				formData.append(
					'sections',
					this.cart.getSectionsToRender().map((section) => section.id)
				);
				formData.append('sections_url', window.location.pathname);
				this.cart.setActiveElement(document.activeElement);
			}
			config.body = formData;

			fetch(`${routes.cart_add_url}`, config)
				.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: 'product-form',
								productVariantId: formData.get('id'),
								errors: response.errors || response.description,
								message: response.message,
							});

							const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
							if (!soldOutMessage) return;
							this.submitButton.setAttribute('aria-disabled', true);
							this.submitButton.querySelector('span').classList.add('hidden');
							soldOutMessage.classList.remove('hidden');
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: 'product-form',
								productVariantId: formData.get('id'),
								cartData: response,
							});
						this.error = false;
						const quickAddModal = this.closest('quick-add-modal');
						if (quickAddModal) {
							document.body.addEventListener(
								'modalClosed',
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							const giftCardModal = document.querySelector('#gift-card-recipient-popup-form');
							const giftCardModalInstance = bootstrap.Modal.getInstance(giftCardModal);

							giftCardModalInstance.hide();
							this.cart.renderContents(response);
						}
					}).catch((e) => {
						console.error(e);
					}).finally(() => {
						this.submitButton.classList.remove('loading');
						if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
						if (!this.error) this.submitButton.removeAttribute('aria-disabled');
						this.querySelector('.loading__spinner').classList.add('hidden');
					});
		}

		clearInputFields() {
			this.emailInput.value = '';
			this.nameInput.value = '';
			this.messageInput.value = '';
		}

		displayErrorMessage(title, body) {
			this.clearErrorMessage();
			//this.errorMessageWrapper.hidden = false;
			if (typeof body === 'object') {
				this.errorMessage.innerText = this.defaultErrorHeader;
				return Object.entries(body).forEach(([key, value]) => {
					const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
					const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
					const placeholderElement = this.querySelector(`${fieldSelector}`);
					const label = placeholderElement?.getAttribute('placeholder') || key;
					const message = `${label} ${value}`;
					const errorMessageElement = this.querySelector(`#${errorMessageId}`);
					const errorTextElement = errorMessageElement?.querySelector('.error-message');
					if (!errorTextElement) return;

					if (this.errorMessageList) {
						this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
					}

					errorTextElement.innerText = `${message}.`;
					errorMessageElement.classList.remove('hidden');

					const inputElement = this[`${key}Input`];
					if (!inputElement) return;

					inputElement.setAttribute('aria-invalid', true);
					inputElement.setAttribute('aria-describedby', errorMessageId);
				});
			}

			this.errorMessage.innerText = body;
		}

		createErrorListItem(target, message) {
			const li = document.createElement('li');
			const a = document.createElement('a');
			a.setAttribute('href', target);
			a.innerText = message;
			li.appendChild(a);
			li.className = 'error-message';
			return li;
		}

		clearErrorMessage() {
			//this.errorMessageWrapper.hidden = true;

			if (this.errorMessageList) this.errorMessageList.innerHTML = '';

			this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
				field.classList.add('hidden');
				const textField = field.querySelector('.error-message');
				if (textField) textField.innerText = '';
			});

			[this.emailInput, this.messageInput, this.nameInput].forEach((inputElement) => {
				inputElement.setAttribute('aria-invalid', false);
				inputElement.removeAttribute('aria-describedby');
			});
		}

		resetRecipientForm() {
			this.clearInputFields();
			this.clearErrorMessage();
		}
	}
);
}